import { Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ComponentPropsWithoutRef } from 'react';

const ABSTAND_ZUM_RAND_PX = 16;

export type PopoverSeite = Extract<
  ComponentPropsWithoutRef<typeof PopoverContent>['side'],
  'right' | 'bottom'
>;

type InfoPopoverProps = {
  text: string;
  label: string;
  seite: PopoverSeite;
};

export function InfoPopover({ text, label, seite }: InfoPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger
        className="flex h-6 w-6 shrink-0 items-center justify-center text-neutrals-700"
        aria-label={label}>
        <FontAwesomeIcon icon={faCircleInfo} />
      </PopoverTrigger>
      <PopoverContent
        side={seite}
        align={seite === 'right' ? 'center' : 'start'}
        collisionPadding={ABSTAND_ZUM_RAND_PX}
        className="w-72 max-w-[calc(100vw-2rem)] border-neutrals-200 p-3 text-sm text-neutrals-900">
        {text}
      </PopoverContent>
    </Popover>
  );
}
